<script setup lang="ts">
    import type { Asset, AuthorData } from '~/@types/cms';

    interface BlogHeaderProps {
        title: string;
        subtitle?: string;
        hero?: Asset;
        tag?: string;
        date?: string;
        author?: AuthorData;
    }
    const props = defineProps<BlogHeaderProps>();

    const { d } = useLocales();
    const { setHeader } = useMicroDataStore();
    setHeader({
        name: props.title,
        description: removeWoomTextFormat(props.subtitle),
        datePublished: props.date,
        author: props.author,
        asset: props.hero,
    });
</script>
<template>
    <atm-grid
        tag="section"
        class="mol-blog-header py-12">
        <div
            v-if="tag"
            class="col-span-2 mb-8 text-center font-mono text-xs md:col-start-6">
            {{ tag }}
        </div>
        <atm-heading
            level="h1"
            size="2xl"
            class="col-span-2 break-words text-center md:col-span-8 md:col-start-3">
            <renderer-html :content="woomTextFormat(title)" />
        </atm-heading>

        <div
            v-if="subtitle"
            class="col-span-2 text-center text-base md:col-span-8 md:col-start-3">
            <renderer-html :content="subtitle" />
        </div>
        <div
            v-if="author || date"
            class="col-span-2 mx-auto flex items-center gap-2 font-mono text-xs md:col-span-4 md:col-start-5">
            <div
                v-if="author"
                class="flex-no-wrap flex items-center gap-2">
                <nuxt-img
                    :src="author?.image"
                    class="h-8 w-8 rounded-full"
                    width="100"></nuxt-img>
                <div class="whitespace-no-wrap">{{ author.name }}<template v-if="date">, </template></div>
            </div>
            <div v-if="date">{{ d(date) }}</div>
        </div>
        <div
            v-if="hero"
            class="col-span-2 mt-12 flex justify-center md:col-span-12">
            <lazy-atm-asset
                :data="hero"
                sizes="100vw md:1264px lg:1400px" />
        </div>
    </atm-grid>
</template>
